import { config } from '@services/config';
import { JurisdictionSearchRequestQuery, JurisdictionSearchResponse } from '@lio/api-types';
import { queryKeys } from '@services/jurisdiction/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const getJurisdictionsQuery = (params: JurisdictionSearchRequestQuery) => {
  const { name, abbreviation, sort } = params;
  const query = new URLSearchParams();
  if (name) {
    query.append('name', name);
  }
  if (abbreviation) {
    query.append('abbreviation', String(abbreviation));
  }
  if (sort) {
    query.append('sort', sort.toString());
  }
  return query.toString();
};

export const useJurisdictions = (params: JurisdictionSearchRequestQuery & { enabled?: boolean }) => {
  const client = useClient();
  const query = getJurisdictionsQuery(params);
  const result = useQuery({
    queryKey: queryKeys.jurisdictions,
    queryFn: async () => {
      const response = await client.get(`jurisdiction?${query}`).json<JurisdictionSearchResponse>();
      return response.items;
    },
    enabled: params.enabled ?? true,
    ...config,
  });
  return { ...result, jurisdictions: result.data || [] };
};
